// extracted by mini-css-extract-plugin
export default {"tag":"q2dfvIirP6a0PlEhx9kR","content":"tFFXak_PLivFUn0JiVI7","text":"ibVrGUuu8llZolgK896D"};